export default __webpack_public_path__ + "static/media/mousewithhouse.42d48840.png";